import React, { useCallback, useEffect, useRef, useState } from 'react'
import { secondsToMinutes } from '../utils/format-time'

interface TimerProps {
	isActive: boolean
	timeAdded: number
	onTimeUp: (matchTime: number) => void
}

export const Timer = React.memo(({ isActive, timeAdded, onTimeUp }: TimerProps) => {
	const [timeLeft, setTimeLeft] = useState(120)
	const lastTimeAddedRef = useRef(0)
	const matchStartTimeRef = useRef(0)

	const handleTimeUp = useCallback(() => {
		const matchTime = Math.floor((Date.now() - matchStartTimeRef.current) / 1000)
		onTimeUp(matchTime)
	}, [])

	useEffect(() => {
		if (timeAdded > lastTimeAddedRef.current) {
			const bonusTime = timeAdded - lastTimeAddedRef.current
			setTimeLeft((prev) => prev + bonusTime)
			lastTimeAddedRef.current = timeAdded
		}
	}, [timeAdded])

	useEffect(() => {
		if (!isActive) return

		setTimeLeft(120)
		lastTimeAddedRef.current = 0
		matchStartTimeRef.current = Date.now()

		const timer = setInterval(() => {
			setTimeLeft((prev) => {
				if (prev <= 1) {
					handleTimeUp()
					return 0
				}
				return prev - 1
			})
		}, 1000)

		return () => clearInterval(timer)
	}, [isActive, handleTimeUp])

	return (
		<div className="grid">
			<strong className="text-xs">Tempo</strong>
			<span className="text-3xl">{secondsToMinutes(timeLeft)}</span>
		</div>
	)
})
